import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { SessionStorage } from "ngx-webstorage";
import { TimesheetReportService } from "./timesheet-report.service";
import { DatePipe } from "@angular/common";
import { IMyOptions } from "mydatepicker";
import {
  PendingTimesheet,
  ExportData,
  Timesheet,
  ExportAnalyticscoeDetailedView,
} from "./timesheet-report";
import { ReportHierarchyComponent } from "../organizational-report/report-hierarchy/report-hierarchy.component";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ExportExcelService } from "../../utils/services/export-excel.service";

@Component({
  selector: "app-timesheet-report",
  templateUrl: "./timesheet-report.component.html",
  styleUrls: ["./timesheet-report.component.css"],
})
export class TimesheetReportComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public startDate: any;
  public endDate: any;
  public projectlistarr = [];
  public employee: Array<any> = [];
  public filteredOptions: Array<any> = [];
  public pendingTimesheetList: Array<any> = [];
  public pendingTimesheet: any = new PendingTimesheet({});
  public exportData: any = new ExportData({});
  public exportDetailedData: Array<any> = [];
  public totalElements: number = 0;
  public empName: string = "";
  public isLoading: boolean = false;
  public pageNumber: number = 1;
  public pageSize: number = 10;

  @ViewChild(ReportHierarchyComponent) child;

  constructor(
    private snackBar: MatSnackBar,
    public reportService: TimesheetReportService,
    private datePipe: DatePipe,
    private spinnerService: Ng4LoadingSpinnerService,
    private exportExcel: ExportExcelService
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };

    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };
  }

  ngOnInit() {
    this.reportService.setDateStatus({ startDate: "", endDate: "" });
    this.employeeList();
  }

  /** 🔍 Local filter for employees */
  autoCompleteFilter(event: any) {
    const searchItem = event.target.value ? event.target.value.trim().toLowerCase() : "";
    if (searchItem) {
      this.filteredOptions = this.employee.filter(
        (emp: any) =>
          emp.Empname.toLowerCase().includes(searchItem) ||
          emp.EmailID.toLowerCase().includes(searchItem) ||
          emp.Empno_legacy.toLowerCase().includes(searchItem)
      );
    } else {
      this.filteredOptions = this.employee;
    }
  }

get tableHeaders(): string[] {
  // ✅ Define preferred header order once
  const preferredOrder = [
    "Employee Name",
    "Employee No",
    "Email ID",
    "Project Manager",
    "Filled Hrs",
    "Leave Details",
    "EmpDepartment",
    "Client",
    "ClientEmailID",
    "Project Name",
    "Project Type",
    "Activity Name",
    "Timesheet Date",
    "Submission Date",
    "Approval Status",
    "Emp Status",
    "Target ID",
    "Steps",
    "Reactions",
    "Prod Reactions",
    "Successful Reactions"
  ];

  // 🚫 No data? Return empty list
  if (!this.exportData || !this.exportData.data || !this.exportData.data.length) {
    return [];
  }

  // ✅ Collect all keys from current dataset
  const dataKeys = new Set<string>();
  this.exportData.data.forEach((item: any) => {
    Object.keys(item).forEach(key => dataKeys.add(key));
  });

  // ✅ Return only headers that exist in data, keeping preferred order
  return preferredOrder.filter(header => dataKeys.has(header));
}



  /** Show all employees on focus */
  showAllEmployees() {
    if (this.employee && this.employee.length > 0) {
      this.filteredOptions = this.employee;
    }
  }

  /** Select a specific employee */
  pendingTimesheetEmployee(option: any) {
    this.pendingTimesheet.empno = option.Empno;
    this.empName = option.Empname;
    this.getPendingTimesheet();
  }

  /** Select all employees */
  selectAllEmployees() {
    this.empName = "All Employees";
    this.pendingTimesheet.empno = null;
    this.getPendingTimesheet();
  }

  /** Get timesheet data */
  getPendingTimesheet() {
    this.pendingTimesheetList = [];

    if (this.startDate) {
      const startDate = this.startDate.formatted.split("-");
      this.myDatePickerEndOptions.disableUntil = {
        year: parseInt(startDate[2], 10),
        month: parseInt(startDate[1], 10),
        day: parseInt(startDate[0], 10),
      };
    }

    if (this.startDate && this.endDate) {
      this.spinnerService.show();
      this.pendingTimesheet.selectedstartDate = this.startDate
        ? this.datePipe.transform(this.startDate.jsdate, "yyyy-MM-dd")
        : "";
      this.pendingTimesheet.selectedendDate = this.endDate
        ? this.datePipe.transform(this.endDate.jsdate, "yyyy-MM-dd")
        : "";
      this.pendingTimesheet.pageNumber = this.pageNumber;
      this.pendingTimesheet.pageSize = this.pageSize;
      this.pendingTimesheet.flag = 0;

      this.reportService.getTimesheetReport(this.pendingTimesheet).subscribe(
        (data) => {
          this.spinnerService.hide();

          if (data.payload && data.payload.reports) {
            data.payload.reports.forEach((value) =>
              this.pendingTimesheetList.push(new Timesheet(value, 1))
            );

            this.exportData.data = this.pendingTimesheetList;
            if (this.config.businessUnit == "aps") {
              this.exportDetailedData = [];
              data.payload.reports.forEach((value) =>
                this.exportDetailedData.push(
                  new ExportAnalyticscoeDetailedView(value, 1)
                )
              );
            }

            if (this.config.businessUnit == "aps") {
              this.exportData.fileName = this.exportData.pageHeading = data.payload.reports[0]
                ? data.payload.reports[0].empName +
                  "_" +
                  data.payload.reports[0].empno
                : "";
            } else {
              this.exportData.fileName = this.exportData.pageHeading =
                "Detailed_Timesheet_Report";
            }
            this.exportData.flag = false;
            this.totalElements = data.payload.totalReport;
          }
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
    } else {
      this.spinnerService.hide();
      this.exportData.data = [];
      this.exportDetailedData = [];
    }
  }

  /** Export report */
  exportCSV() {
    const options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      showTitle: true,
      title: this.exportData.fileName,
      useBom: true,
    };

    this.pendingTimesheet.reportExport = false;
    this.spinnerService.show();

    this.reportService.getTimesheetReport(this.pendingTimesheet).subscribe(
      (data) => {
        this.pendingTimesheet.reportExport = true;

        this.exportDetailedData = [];
        if (this.config.businessUnit === "aps") {
          data.payload.reports.forEach((value) =>
            this.exportDetailedData.push(
              new Timesheet(value, 1)
            )
          );

          if (this.exportData.data.length > 0) {
            this.exportData.flag = false;
            this.totalElements = data.payload.totalReport;

            const startDate = this.pendingTimesheet.selectedstartDate
              ? this.datePipe.transform(
                  this.pendingTimesheet.selectedstartDate,
                  "dd-MM-yyyy"
                )
              : "";
            const endDate = this.pendingTimesheet.selectedendDate
              ? this.datePipe.transform(
                  this.pendingTimesheet.selectedendDate,
                  "dd-MM-yyyy"
                )
              : "";

            let fileLabel = "";

            if (this.pendingTimesheet.empno === null) {
              fileLabel = `All_Employees_FROM_${startDate}_TO_${endDate}`;
            } else {
              fileLabel =
                data.payload.reports[0].empName +
                "_" +
                data.payload.reports[0].empno +
                "_FROM_" +
                startDate +
                "_TO_" +
                endDate;
            }

            this.exportData.fileName = this.exportData.pageHeading = fileLabel;
            this.exportExcel.JSONToCSVConvertor(
              this.exportDetailedData,
              this.exportData.fileName,
              fileLabel,
              true,
              true
            );
          } else {
            this.snackBar.open("No data to export", "OK", { duration: 3000 });
          }
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  /** Pagination */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getPendingTimesheet();
  }

  /** Get employee list from API */
  employeeList() {
    this.employee = [];
    this.reportService.getEmployee(this.user.Empno).subscribe((data) => {
      if (data.payload && data.payload.length > 0) {
        this.employee = data.payload;
        this.filteredOptions = this.employee;
      }
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/rm/timesheet-report/timesheet-report.component.ts